
import PopupVideo from "../common/PopupVideo";

const OurMission = () => {
  const missionContent = [
    {
      id: 1,
      icon: "flaticon-user",
      number: "80,123",
      meta: "Customers to date",
    },
    {
      id: 2,
      icon: "flaticon-home",
      number: "$74 Billion",
      meta: "In home sales",
    },
    {
      id: 3,
      icon: "flaticon-transfer",
      number: "$468 Million",
      meta: "In Savings",
    },
  ];

  return (
    <>
      <div className="col-lg-6 col-xl-6">
        <div className="about_content">
          <h2>What's Hubzu?</h2>
          <p>
          Hubzu is the place to find unique properties at fair prices - just a click away. 
          By providing one of the largest online home auction marketing platforms, 
          Hubzu allows institutions to market their inventory directly to serious buyers and investors. Our smart 
          tech and streamlined process make transactions faster and easier for both buyers and sellers.
          </p>

          {/* End .ab_counting */}
        </div>
      </div>
      {/* End .col */}

      <div className="col-lg-6 col-xl-6">
      <iframe className='about_thumb video w100' 
        style={{width:100, height:290}}
        title='Youtube player'
        sandbox='allow-same-origin allow-forms allow-popups allow-scripts allow-presentation'
        src={`https://youtube.com/embed/R3XgV7KSjHY?autoplay=0`}>
       </iframe>
        {/* <div className="about_thumb">
          <p>HOW TO: Search and Register for Free on Hubzu</p>
          <img
            className="img-fluid w100 cover"
            src="https://i.ytimg.com/vi_webp/R3XgV7KSjHY/sddefault.webp"
            alt="1.jpg"
          />
          <PopupVideo />
        </div> */}
      </div>
    </>
  );
};

export default OurMission;
